// src/api/productApi.js
// The store is LIVE: never fall back to the static demo catalog — showing
// phantom products whose pages don't exist is worse than a retryable error.
import api from './axios';

const TIMEOUT = 10000;

export const productApi = {

  /**
   * List products with filters
   * @param {Object} params — keyword, category, brand, minPrice, maxPrice,
   *                          minRating, discount, badge, sort, page, limit
   */
  getProducts: (params = {}) =>
    api.get('/products', { params, timeout: TIMEOUT }).then(r => r.data),

  /** Single product detail + reviews */
  getProduct: (id) =>
    api.get(`/products/${id}`, { timeout: TIMEOUT }).then(r => r.data),

  /** Featured products for homepage (up to 8; API falls back to newest) */
  getFeatured: () =>
    api.get('/products/featured', { timeout: TIMEOUT }).then(r => r.data),

  /** Category list with product counts */
  getCategories: () =>
    api.get('/products/categories', { timeout: TIMEOUT }).then(r => r.data),

  /** Brand list with product counts; optional category scopes the list */
  getBrands: (category) =>
    api.get('/products/brands', { params: category ? { category } : {}, timeout: TIMEOUT }).then(r => r.data),

  /** Post a review */
  addReview: (productId, { rating, comment }) =>
    api.post(`/products/${productId}/reviews`, { rating, comment }).then(r => r.data),

  // ── Admin ───────────────────────────────────────────────────────────────

  createProduct: (data) =>
    api.post('/products', data).then(r => r.data),

  updateProduct: (id, data) =>
    api.put(`/products/${id}`, data).then(r => r.data),

  deleteProduct: (id) =>
    api.delete(`/products/${id}`).then(r => r.data),
};
